import {
    CreateAdmin,
    CreateCompanyAdmin,
    CreateMerchantAdmin,
    CreateSupplierAdmin,
    CreateSupportAdmin,
    CreateTenantAdmin,
} from "../../../users/userTypes"
import { UnreachableCaseError, falsyToUndefined } from "../../../../lib/lang"
import { UserType } from "../../../login/loginTypes"
import { CreateEditTenantAdminFormValues } from "../organization/administrators/tenantAdminTypes"

type UserDetails = {
    companyId?: number
    userGroupId?: number
}

export function createUserBody(
    { type }: Pick<CreateAdmin, "type">,
    values: CreateEditTenantAdminFormValues,
    details: UserDetails,
    user?: CreateAdmin,
): CreateAdmin {
    const adminData: Partial<CreateAdmin> = {
        type,
        user: {
            username: falsyToUndefined(values.username),
            displayName: values.displayName,
            email: values.email,
            mobileNumber: falsyToUndefined(values.mobileNumber),
        },
        securitySettings: {
            allowToCreateAdmins: values.allowToCreateAdmins,
            restrictAccessToIpAddresses: values.restrictAccessToIpAddresses,
            ...(values.pinCode ? { pinCode: { value: values.pinCode } } : {}),
        },
        roles: values.roles,
    }

    switch (type) {
        case UserType.OFFICE_MANAGER:
            const officeManagerDetails =
                user && "officeManagerDetails" in user
                    ? user.officeManagerDetails
                    : {
                          companyId: details.companyId ?? 0,
                          userGroupId: details.userGroupId ?? 0,
                      }

            return {
                ...adminData,
                officeManagerDetails,
            } as CreateTenantAdmin

        case UserType.MERCHANT:
            const merchantDetails =
                user && "merchantDetails" in user
                    ? user.merchantDetails
                    : {
                          companyId: details.companyId ?? 0,
                      }

            return {
                ...adminData,
                merchantDetails,
            } as CreateMerchantAdmin

        case UserType.COMPANY:
            const companyDetails =
                user && "companyDetails" in user
                    ? user.companyDetails
                    : {
                          companyId: details.companyId ?? 0,
                      }

            return {
                ...adminData,
                companyDetails,
            } as CreateCompanyAdmin

        case UserType.SUPPLIER:
            const supplierDetails =
                user && "supplierDetails" in user
                    ? user.supplierDetails
                    : {
                          companyId: details.companyId ?? 0,
                      }

            return {
                ...adminData,
                supplierDetails,
            } as CreateSupplierAdmin

        case UserType.SUPPORT:
            return adminData as CreateSupportAdmin

        default:
            throw new UnreachableCaseError(type)
    }
}
